
import { Link } from "react-router-dom";


function App() {

  return (
    <>
      <div className="m-0 h-screen p-8 bg-gradient-to-br from-green-500 to-indigo-500 via-violet-400">
        <div className="p-7 flex justify-center"><Link to={"/adminlogin"}><div className="bg-red-700 hover:bg-green-600 hover:text-2xl text-white rounded-full p-4">Admin Login</div></Link></div>

        <div className="p-7 flex justify-center"><Link to={"/dashboard"}><div className="bg-red-700 hover:bg-green-600 hover:text-2xl text-white rounded-full p-4">Dashboard</div></Link></div>

        {/* <div className="p-7 flex justify-center"><Link to={"/public"}><div className="bg-red-700 hover:bg-green-600 hover:text-2xl text-white rounded-full p-4">LIVE</div></Link></div> */}
      </div>

    </>
  )
}

export default App
